import { RouteObject } from 'react-router';
import { PATHS } from '../../routes/paths';
import { FaqPage } from './pages';

export const faqRoutes: RouteObject[] = [
  {
    path: PATHS.faq,
    Component: FaqPage,
  },
];
